import React from "react";
import ReactPaginate from "react-paginate";
import "./Paginate.web.css";

type PaginateProps = {
  pageCount: number;
  selectedPage: number;
  handlePageClick: (event: any) => void;
};

const Paginate: React.FC<PaginateProps> = ({
  pageCount,
  selectedPage,
  handlePageClick,
}) => {
  return (
    <ReactPaginate
      containerClassName="pagination"
      activeClassName={"pagination_active"}
      pageClassName={"pagination_page-item"}
      disabledClassName={"pagination_disabled"}
      previousClassName={"pagination_previous-link"}
      nextClassName={"pagination_next-link"}
      breakClassName={"pagination_break"}
      breakLabel="..."
      nextLabel=">"
      previousLabel="<"
      onPageChange={handlePageClick}
      renderOnZeroPageCount={null}
      pageRangeDisplayed={3}
      pageCount={pageCount}
      forcePage={selectedPage}
    />
  );
};

export default Paginate;
